import { PayloadAction } from '@reduxjs/toolkit';
import { ILoadingStateWithData } from 'types/reducerState';
/**
 * Please provide function overloading here
 */

export const initialStateUpdate = (
  state: ILoadingStateWithData<any>,
  initialState: any,
) => {
  state.data = initialState;
  state.error = false;
  state.loading = true;
};

export const successStateUpdate = (
  state: ILoadingStateWithData<any>,
  data: PayloadAction<any>,
) => {
  state.data = data.payload;
  state.error = false;
  state.loading = false;
};

export const failureStateUpdate = (
  state: ILoadingStateWithData<any>,
  initialState: any,
) => {
  state.data = initialState;
  state.error = true;
  state.loading = false;
};
